import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import StaticPen from '../components/StaticPen/StaticPen';
import * as staticPenActionCreators from '../actions/actionCreators/staticPen';
import { setCheckoutBehaviour, setStep } from '../actions/actionCreators/checkout';

function mapStateToProps(state) {

    state.configurator = {};
    return {
        locale: state.app.locale,
        ...state.staticPen,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(staticPenActionCreators, dispatch),
        ...bindActionCreators({ setCheckoutBehaviour, setStep }, dispatch),
    };
}

const StaticPenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(StaticPen);

export default StaticPenContainer;
